import { PropsWithChildren } from "react";

import { TemplateCategory } from "@/components/confluence/templates/template-categories-search";
import type {
    Template,
    TemplateCollection
} from "@/content/templates/template.types";
import { ConfluenceTemplatesUnifiedPageTemplate as ConfluenceTemplatesUnifiedPageTemplate } from "@/templates/software/confluence/templates/confluence-templates-page/src/confluence-templates-unified-page.template.tsx";

export type ConfluenceTemplateSearchPageTemplateProps = PropsWithChildren<{
    templates?: Template[];
    partnerTemplates?: Template[];
    collections?: TemplateCollection[];
    categories?: TemplateCategory[];
}>;

export const ConfluenceTemplateSearchPageTemplate = ({
    templates,
    partnerTemplates,
    collections,
    categories
}: ConfluenceTemplateSearchPageTemplateProps) => {
    return (
        <ConfluenceTemplatesUnifiedPageTemplate
            templates={templates}
            categories={categories}
            collections={collections}
            partnerTemplates={partnerTemplates}
        />
    );
};
